<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M5.59 7.41L7 6l6 6-6 6-1.41-1.41L10.17 12 5.59 7.41m6 0L13 6l6 6-6 6-1.41-1.41L16.17 12l-4.58-4.59Z"/>
    </svg>
</template>

<script>
export default {
    name: 'ChevronDoubleRightIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
